import type { PcmpMarketingQueueCounts, PcmpMarketingTab } from '../types/pcmpMarketing.types';

export const PCMP_MARKETING_DEFAULT_TAB: PcmpMarketingTab = 'AWAITING';

export const PCMP_MARKETING_TAB_LABELS = {
  AWAITING: 'Awaiting My Action',
  ACTIONABLE: 'My Actions',
  ALL: 'All Proposals',
  BATCHES: 'Batches',
  MIS_NOT_VERIFIED: 'MIS Not Verified',
  ON_HOLD: 'On Hold',
  PROPOSAL_CORRECTION: 'Proposal Correction',
} as const satisfies Record<PcmpMarketingTab, string>;

/** The badge of each tab, from the counts endpoint. */
export const PCMP_MARKETING_TAB_COUNT = {
  AWAITING: (counts) => counts.awaiting,
  ACTIONABLE: (counts) => counts.actionable,
  ALL: (counts) => counts.all,
  BATCHES: (counts) => counts.batches,
  MIS_NOT_VERIFIED: (counts) => counts.misNotVerified + counts.misExplained,
  ON_HOLD: (counts) => counts.onHold,
  PROPOSAL_CORRECTION: (counts) => counts.proposalCorrection ?? 0,
} as const satisfies Record<PcmpMarketingTab, (counts: PcmpMarketingQueueCounts) => number>;
